import { render, staticRenderFns } from "./MacOsPushPreview.vue?vue&type=template&id=2319cf0a&scoped=true&"
import script from "./MacOsPushPreview.vue?vue&type=script&lang=ts&"
export * from "./MacOsPushPreview.vue?vue&type=script&lang=ts&"
import style0 from "./MacOsPushPreview.vue?vue&type=style&index=0&id=2319cf0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2319cf0a",
  null
  
)

export default component.exports